import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  toString1pkumu07cwy4m as toString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
} from './kotlin-kotlin-stdlib.mjs';
import {
  send19n2gpocr878u as send,
  send33czqa1op8y08 as send_0,
  readBytes28s4uf7ekyufa as readBytes,
  Binary3tlzyfojm51s4 as Binary,
  readText30p9xkeoodw49 as readText,
  Text3e6ukp9joohql as Text,
} from './ktor-ktor-websockets.mjs';
import {
  BinaryMessage1vcfklwl6l2fk as BinaryMessage,
  StringMessage2xq2dimbrolxk as StringMessage,
} from './kotlinx-rpc-krpc-krpc-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class KtorTransport {
  constructor(webSocketSession) {
    this.t90_1 = webSocketSession;
  }
  *l8r(message, $completion) {
    if (message instanceof StringMessage) {
      yield* send_0(this.t90_1, message.b8p_1, $completion);
    } else {
      if (message instanceof BinaryMessage) {
        yield* send(this.t90_1, message.c8p_1, $completion);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return Unit_instance;
  }
  *d8p($completion) {
    var message = yield* this.t90_1.t7z().n22($completion);
    var tmp;
    if (message instanceof Text) {
      tmp = new StringMessage(readText(message));
    } else {
      if (message instanceof Binary) {
        tmp = new BinaryMessage(readBytes(message));
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Unsupported websocket frame type: ' + toString(getKClassFromExpression(message)) + '. Expected Frame.Text or Frame.Binary';
        throw IllegalStateException.o(toString(message_0));
      }
    }
    return tmp;
  }
  d1m() {
    return this.t90_1.d1m();
  }
}
//endregion
//region block: post-declaration
initMetadataForClass(KtorTransport, 'KtorTransport', VOID, VOID, VOID, [1, 0]);
//endregion
//region block: exports
export {
  KtorTransport as KtorTransporty9yzfrgq92as,
};
//endregion
